if ($('.product-ingredients__carousel').length > 0) {
  let initialSlide = 0;
  const $beforeAfterSlider = $('.product-ingredients__carousel');

  $beforeAfterSlider.each(function(index, el) {
    const isActive = $(this).hasClass("active");
    if(isActive) {
      initialSlide = index;
    }
  })

  const $progressBar = $('.product-ingredients .progress');
  const $progressBarLabel = $( '.product-ingredients .slider__label' );

  $beforeAfterSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    let calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

    console.log('slide number', currentSlide);

    if ($(window).width() >= 768){
      if (calc == 75){
        calc = 100;
      }
    }

    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );

    $progressBarLabel.text( calc + '% completed' );
  });


  $('.product-ingredients__carousel').slick({
    infinite: false,
    dots: false,
    centerMode: false,
    centerPadding: '20px',
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          infinite: false,
          dots: false,
          centerMode: false,
          centerPadding: '20px',
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          initialSlide: initialSlide,
        }
      },
      {
        breakpoint: 990,
        settings: {
          infinite: false,
          dots: false,
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          initialSlide: initialSlide,
        }
      }
    ]
  });
}